export class PagedZohoBookBillDetail {
    currentPage: number;
    totalPages: number;
    pageSize: number;
    totalCount: number;
    items: any[] = [];
}
